function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 8V10.2834C1 10.4261 1.03068 10.5688 1.09186 10.6978C2.70533 14.0994 5.21988 15.6696 6.91559 16.2438C7.48012 16.435 8 15.9787 8 15.3827V14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14V15.1907C16 15.8501 16.6293 16.3295 17.2417 16.0849C20.6716 14.7149 22.4203 12.0535 22.9458 10.6527C22.9836 10.552 23 10.4452 23 10.3377V8C23 6.89543 22.1046 6 21 6H3C1.89543 6 1 6.89543 1 8Z",
  fill: "#738AA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 21V14.7C23 14.3156 22.4935 14.1404 22.2341 14.424C20.3934 16.436 18.2512 17.4292 16.8618 17.818C16.3762 17.9539 16 18.3785 16 18.8828V20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20V19C8 18.4477 7.54952 18.0078 7.0038 17.9228C4.73695 17.57 2.95964 16.0719 1.87977 14.7648C1.61688 14.4466 1 14.6309 1 15.0437V21C1 22.1046 1.89543 23 3 23H21C22.1046 23 23 22.1046 23 21Z",
  fill: "#738AA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.35185 3.55144C8.19524 3.75279 8.09016 4.03433 8.03812 4.40157C7.99163 4.72967 7.73137 5 7.4 5H6.6C6.26863 5 5.9959 4.73087 6.02559 4.40083C6.08766 3.71078 6.27917 2.95867 6.77315 2.32356C7.45478 1.44717 8.543 1 10 1H14C15.1541 1 16.2034 1.28921 16.9571 2.04289C17.578 2.66379 17.8837 3.48531 17.9721 4.4008C18.004 4.73064 17.7314 5 17.4 5H16.6C16.2686 5 16.0087 4.72929 15.958 4.40182C15.8846 3.92741 15.7233 3.63747 15.5429 3.45711C15.2966 3.21079 14.8459 3 14 3H10C8.957 3 8.54522 3.30283 8.35185 3.55144Z",
  fill: "#738AA5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 15.5C9.5 14.9477 9.94772 14.5 10.5 14.5H13.5C14.0523 14.5 14.5 14.9477 14.5 15.5V18.5C14.5 19.0523 14.0523 19.5 13.5 19.5H10.5C9.94772 19.5 9.5 19.0523 9.5 18.5V15.5Z",
  fill: "#738AA5"
});

function SvgDealIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealIcon);
export default __webpack_public_path__ + "static/media/DealIcon.aeb97eb3.svg";
export { ForwardRef as ReactComponent };